import { User } from "types/entities";

import resourceOperations from "../resourceOperations";

const operation = resourceOperations({
  basePath: "/api/admin/users",
  baseKey: "users",
  dataKey: "user",
  versioned: false,
});

export const useUsers = (opts = {}) => operation.useRead<User[]>(null, opts);

export const useUser = (id: number, opts = {}) => operation.useRead<User>(id, opts);
export const useCreateUser = (opts = {}) => operation.useCreate<User>(null, opts);

export const useUpdateUser = (id: number, opts = {}) => operation.useUpdate<User>(id, opts);
